import { all } from 'typed-redux-saga';

import { appSideEffects } from './app/saga';
import { asesSideEffects } from './ases/sagas';
import { assessmentSideEffects } from './assessments/sagas';
import { assetSideEffects } from './assets/sagas';
import { authSideEffects } from './auth/sagas';
import { errorSideEffects } from './error/sagas';
import { filesSideEffects } from './files/sagas';
import { organisationSideEffects } from './organisations/sagas';
import { planSideEffects } from './plan/sagas';
import { remoteSideEffects } from './remote/sagas';
import { searchSideEffects } from './search/sagas';
import { syncSideEffects } from './sync/sagas';
import { engageSagas } from './remote/engageSagas';

const sagas = [
  ...appSideEffects,
  ...authSideEffects,
  ...remoteSideEffects,
  ...assessmentSideEffects,
  ...assetSideEffects,
  ...organisationSideEffects,
  ...searchSideEffects,
  ...syncSideEffects,
  ...errorSideEffects,
  ...planSideEffects,
  ...asesSideEffects,
  ...filesSideEffects,

  // Engage
  ...engageSagas,
];

export function* rootSaga(): Generator {
  yield all(sagas);
}
